module.exports = __webpack_public_path__ + "static/media/creditArrow.33b2a4cf.svg";